import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageCurrentOfLast: {
    id: 'pagination.pageCurrentOfLast',
    defaultMessage: 'Page {currentPage} of {lastPage}',
    description: 'Pagination Page {currentPage} of {lastPage}',
  },
  rowsPerPage: {
    id: 'pagination.rowsPerPage',
    defaultMessage: 'Rows per page',
    description: 'Pagination Rows per page',
  },
  resultsPerPage: {
    id: 'pagination.resultsPerPage',
    defaultMessage: 'Results per page',
    description: 'Pagination Results per page',
  },
});

export default messages;
